export type SqliteConnectRuntime<T> = {
  checkConnectionsConsistency: () => Promise<unknown>
  isConnection: (dbName: string, readonly: boolean) => Promise<{ result?: boolean }>
  retrieveConnection: (dbName: string, readonly: boolean) => Promise<T>
  createConnection: (
    dbName: string,
    encrypted: boolean,
    mode: string,
    version: number,
    readonly: boolean,
  ) => Promise<T>
  open: (db: T) => Promise<unknown>
  isDBOpen: (db: T) => Promise<{ result?: boolean }>
  createKeyValueTable: (db: T) => Promise<unknown>
}

export async function establishSqliteConnection<T> (
  dbKey: string,
  store: Record<string, T | undefined>,
  runtime: SqliteConnectRuntime<T>,
): Promise<T> {
  const dbName = `${dbKey}.db`
  await runtime.checkConnectionsConsistency()
  const connectionExists = await runtime.isConnection(dbName, false)

  if (connectionExists.result) {
    store[dbKey] = await runtime.retrieveConnection(dbName, false)
  } else {
    store[dbKey] = await runtime.createConnection(dbName, false, 'no-encryption', 1, false)
    const created = store[dbKey]
    if (!created) {
      throw new Error('error creating database connection')
    }
    await runtime.open(created)
  }

  const db = store[dbKey]
  if (!db) {
    throw new Error('error creating database connection')
  }

  const opened = await runtime.isDBOpen(db)
  if (!opened.result) {
    await runtime.open(db)
  }

  await runtime.createKeyValueTable(db)
  return db
}
